
















import { Component, Vue } from 'vue-property-decorator'
import { Mutation } from 'vuex-class'
const StartNavigation = () => import(/* webpackChunkName: "StartNavigation", webpackPrefetch: true */ '@/components/StartNavigation.vue')
const GamblingPage = () => import(/* webpackChunkName: "GamblingPage", webpackPrefetch: true */ '@/pages/Gambling/GamblingPage.vue')
const EcommercePage = () => import(/* webpackChunkName: "EcommercePage" */ '@/pages/Ecommerce/EcommercePage.vue')
import { setCheckoutTheme, checkForSavedConfigs, clearOldWebstorage } from '@/utils/gamblingHelpers'
import { CheckForSavedConfigsCtx } from '@/utils/interfaces'

@Component({
  components: {
    StartNavigation,
    GamblingPage,
    EcommercePage
  }
})

export default class App extends Vue {
  @Mutation('setCashierSpinner') setCashierSpinner: any
  @Mutation('setPageLayout') setPageLayout: any

    get startPage() {
    return this.$route.path === '/'
  }
  created () {
    const savedConfigs: Partial<CheckForSavedConfigsCtx> = checkForSavedConfigs()
    if (savedConfigs && savedConfigs.demoThemesOptions) {
      savedConfigs.demoThemesOptions.spinner && this.setCashierSpinner(savedConfigs.demoThemesOptions.spinner)
      savedConfigs.demoThemesOptions.checkoutBg && setCheckoutTheme(savedConfigs.demoThemesOptions.checkoutBg)
      savedConfigs.demoThemesOptions.pageLayout && this.setPageLayout(savedConfigs.demoThemesOptions.pageLayout)
    }
  }

  mounted () {
    setTimeout(clearOldWebstorage, 2000)
  }
}
